export enum TradelaneClassification {
  Preferred = 'PREFERRED',
  Restricted = 'RESTRICTED',
}
